export enum SmsChatConversationHeaderVariant {
    DEFAULT = 'default',
    SLIDEOVER = 'slideover',
    SLIDEOVER_COLLAPSED = 'slideover-collapsed',
}
